import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DialogState {
  openTime: number | null;
  duration: number;
}

const initialState: DialogState = {
  openTime: null,
  duration: 0,
};

const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    setDialogOpenTimeCount: (state, action: PayloadAction<number | null>) => {
      state.openTime = action.payload;
    },
    setDialogDurationCount: (state, action: PayloadAction<number>) => {
      state.duration = action.payload;
    },
  },
});

export const { setDialogOpenTimeCount, setDialogDurationCount } = dialogSlice.actions;
export default dialogSlice.reducer;
